export const RESOURCE_ORDER = [
    'ironOre',
    'copperOre',
    'stone',
    'coal',
    'timber',
    'ironIngot',
    'copperIngot',
    'ironCog',
    'copperWire',
    'siliconOre',
    'siliconBar',
    'greenCircuit'
]

export const RESOURCES = {
    ironOre: { label: 'Iron ore', shortLabel: 'ORE', color: '#c7b7a6', material: 'beige' },
    copperOre: { label: 'Copper ore', shortLabel: 'ORE', color: '#e88b52', material: 'orange' },
    stone: { label: 'Stone', shortLabel: 'STONE', color: '#eeeeea', material: 'white' },
    coal: { label: 'Coal', shortLabel: 'COAL', color: '#45474c', material: 'black' },
    timber: { label: 'Timber', shortLabel: 'WOOD', color: '#a86542', material: 'brown' },
    ironIngot: { label: 'Iron ingot', shortLabel: 'INGOT', color: '#b9c6ca', material: 'metal' },
    copperIngot: { label: 'Copper ingot', shortLabel: 'INGOT', color: '#e88b52', material: 'orange' },
    ironCog: { label: 'Iron cog', shortLabel: 'COG', color: '#b9c6ca', material: 'metal' },
    copperWire: { label: 'Copper wire', shortLabel: 'WIRE', color: '#e88b52', material: 'orange' },
    siliconOre: { label: 'Silicon ore', shortLabel: 'ORE', color: '#62a65b', material: 'green' },
    siliconBar: { label: 'Silicon bar', shortLabel: 'SILICON', color: '#62a65b', material: 'green' },
    greenCircuit: { label: 'Green circuit', shortLabel: 'CIRCUIT', color: '#62a65b', material: 'green' }
}

export const TUNING = {
    backpackCapacity: 20,
    machineSlotCapacity: 10,
    outputCapacity: 10,
    gatherInterval: 0.6,
    transferInterval: 0.22,
    stationaryDelay: 0.22,
    gatherRange: 2.35,
    machineRange: 2.5,
    tileHalfSize: 1.55,
    playerSpeed: 4.2,
    botSpeed: 1.6,
    botCapacity: 4,
    beltSpeed: 2.4,
    beltSpacing: 0.55,
    groundPileCapacity: 10,
    walkRadius: 30,
    treeRegrowSeconds: 45,
    fuelSeconds: { coal: 8, timber: 4 }
}

export const TRAY_SIZES = {
    port: { width: 1.02, depth: 0.82 },
    ground: { width: 1.35, depth: 1.15 }
}

export const DEPOSITS = [
    { id: 'ironPatch', resource: 'ironOre', x: -11.394, y: 7.121, amount: 1800 },
    { id: 'copperPatch', resource: 'copperOre', x: -11.394, y: -7.121, amount: 1800 },
    { id: 'stonePatch', resource: 'stone', x: 10.037, y: 8.603, amount: 1600 },
    { id: 'coalPatch', resource: 'coal', x: 10.255, y: -7.325, amount: 1600 },
    { id: 'siliconPatch', resource: 'siliconOre', x: -11.394, y: -21.363, amount: 1800 },
    { id: 'treeB', resource: 'timber', x: 1, y: 11, amount: 8, tree: true },
    { id: 'treeC', resource: 'timber', x: 4, y: 9, amount: 8, tree: true },
    { id: 'treeD', resource: 'timber', x: -6, y: 10, amount: 8, tree: true },
    { id: 'treeE', resource: 'timber', x: 6, y: 12, amount: 8, tree: true },
    { id: 'treeF', resource: 'timber', x: -11, y: 0, amount: 8, tree: true },
    { id: 'northTree1', resource: 'timber', x: -13, y: 15, amount: 8, tree: true },
    { id: 'northTree2', resource: 'timber', x: -8, y: 15, amount: 8, tree: true },
    { id: 'northTree3', resource: 'timber', x: -3, y: 15, amount: 8, tree: true },
    { id: 'northTree4', resource: 'timber', x: 2, y: 15, amount: 8, tree: true },
    { id: 'northTree5', resource: 'timber', x: 7, y: 15, amount: 8, tree: true },
    { id: 'northTree6', resource: 'timber', x: 12, y: 15, amount: 8, tree: true },
    { id: 'northTree7', resource: 'timber', x: -14, y: 18, amount: 8, tree: true },
    { id: 'northTree8', resource: 'timber', x: -9, y: 18, amount: 8, tree: true },
    { id: 'northTree9', resource: 'timber', x: -4, y: 18, amount: 8, tree: true },
    { id: 'northTree10', resource: 'timber', x: 1, y: 18, amount: 8, tree: true },
    { id: 'northTree11', resource: 'timber', x: 6, y: 18, amount: 8, tree: true },
    { id: 'northTree12', resource: 'timber', x: 11, y: 18, amount: 8, tree: true },
    { id: 'northTree13', resource: 'timber', x: -13, y: 21, amount: 8, tree: true },
    { id: 'northTree14', resource: 'timber', x: -8, y: 21, amount: 8, tree: true },
    { id: 'northTree15', resource: 'timber', x: -3, y: 21, amount: 8, tree: true },
    { id: 'northTree16', resource: 'timber', x: 2, y: 21, amount: 8, tree: true },
    { id: 'northTree17', resource: 'timber', x: 7, y: 21, amount: 8, tree: true },
    { id: 'northTree18', resource: 'timber', x: 12, y: 21, amount: 8, tree: true },
    { id: 'northTree19', resource: 'timber', x: -11, y: 24, amount: 8, tree: true },
    { id: 'northTree20', resource: 'timber', x: -6, y: 24, amount: 8, tree: true },
    { id: 'northTree21', resource: 'timber', x: -1, y: 24, amount: 8, tree: true },
    { id: 'northTree22', resource: 'timber', x: 4, y: 24, amount: 8, tree: true },
    { id: 'northTree23', resource: 'timber', x: 9, y: 24, amount: 8, tree: true },
    { id: 'northTree24', resource: 'timber', x: 14, y: 24, amount: 8, tree: true },
    { id: 'northTree25', resource: 'timber', x: -13, y: 26, amount: 8, tree: true },
    { id: 'northTree26', resource: 'timber', x: -8, y: 26, amount: 8, tree: true },
    { id: 'northTree27', resource: 'timber', x: -3, y: 26, amount: 8, tree: true },
    { id: 'northTree28', resource: 'timber', x: 2, y: 26, amount: 8, tree: true },
    { id: 'northTree29', resource: 'timber', x: 7, y: 26, amount: 8, tree: true },
    { id: 'northTree30', resource: 'timber', x: 12, y: 26, amount: 8, tree: true },
    { id: 'westTree1', resource: 'timber', x: -27.42, y: -7.96, amount: 8, tree: true },
    { id: 'westTree2', resource: 'timber', x: -22.81, y: -5.22, amount: 8, tree: true },
    { id: 'westTree3', resource: 'timber', x: -21.39, y: -10.14, amount: 8, tree: true },
    { id: 'westTree4', resource: 'timber', x: -19.86, y: -5.51, amount: 8, tree: true },
    { id: 'westTree5', resource: 'timber', x: -22.91, y: 4.45, amount: 8, tree: true },
    { id: 'westTree6', resource: 'timber', x: -19.26, y: 2.93, amount: 8, tree: true },
    { id: 'westTree7', resource: 'timber', x: -23.76, y: 8.32, amount: 8, tree: true },
    { id: 'westTree8', resource: 'timber', x: -25.04, y: -10.79, amount: 8, tree: true },
    { id: 'westTree9', resource: 'timber', x: -20.18, y: -8.07, amount: 8, tree: true },
    { id: 'westTree10', resource: 'timber', x: -26.21, y: 1.62, amount: 8, tree: true },
    { id: 'westTree11', resource: 'timber', x: -15.98, y: 4.52, amount: 8, tree: true },
    { id: 'westTree12', resource: 'timber', x: -26.48, y: 10.1, amount: 8, tree: true },
    { id: 'westTree13', resource: 'timber', x: -21.31, y: 10.03, amount: 8, tree: true },
    { id: 'westTree14', resource: 'timber', x: -23.99, y: -8.43, amount: 8, tree: true },
    { id: 'westTree15', resource: 'timber', x: -16.52, y: 10.51, amount: 8, tree: true },
    { id: 'westTree16', resource: 'timber', x: -27.27, y: 7.08, amount: 8, tree: true },
    { id: 'westTree17', resource: 'timber', x: -24.19, y: 0.23, amount: 8, tree: true },
    { id: 'westTree18', resource: 'timber', x: -18.5, y: -11.05, amount: 8, tree: true },
    { id: 'westTree19', resource: 'timber', x: -18.2, y: -6.99, amount: 8, tree: true },
    { id: 'westTree20', resource: 'timber', x: -25.07, y: -5.15, amount: 8, tree: true },
    { id: 'westTree21', resource: 'timber', x: -26.1, y: -2.01, amount: 8, tree: true },
    { id: 'westTree22', resource: 'timber', x: -14.64, y: -3.28, amount: 8, tree: true },
    { id: 'westTree23', resource: 'timber', x: -18.28, y: -2.55, amount: 8, tree: true },
    { id: 'westTree24', resource: 'timber', x: -17.17, y: 0.71, amount: 8, tree: true },
    { id: 'westTree25', resource: 'timber', x: -20.56, y: 5.15, amount: 8, tree: true },
    { id: 'westTree26', resource: 'timber', x: -18.77, y: 8.7, amount: 8, tree: true },
    { id: 'westTree27', resource: 'timber', x: -15.42, y: -10.03, amount: 8, tree: true },
    { id: 'westTree28', resource: 'timber', x: -22.51, y: -2.21, amount: 8, tree: true },
    { id: 'westTree29', resource: 'timber', x: -16.75, y: 7.09, amount: 8, tree: true },
    { id: 'westTree30', resource: 'timber', x: -22.38, y: 1.54, amount: 8, tree: true }
]

export const STORAGE_BIN = { id: 'storageBin', x: 10.255, y: -13.4 }

export const MACHINE_TYPES = {
    ironSmelter: { label: 'Iron smelter', kind: 'smelter', inputs: ['ironOre'], output: 'ironIngot', fuel: true, duration: 2 },
    copperSmelter: { label: 'Copper smelter', kind: 'smelter', inputs: ['copperOre'], output: 'copperIngot', fuel: true, duration: 2 },
    ironFabricator: { label: 'Cog fabricator', kind: 'fabricator', inputs: ['ironIngot'], output: 'ironCog', fuel: false, duration: 1.5 },
    copperFabricator: { label: 'Wire fabricator', kind: 'fabricator', inputs: ['copperIngot'], output: 'copperWire', fuel: false, duration: 1.5 },
    ironDrill: { label: 'Mining drill', kind: 'drill', output: 'ironOre', fuel: true, duration: 2, depositId: 'ironPatch' },
    copperDrill: { label: 'Mining drill', kind: 'drill', output: 'copperOre', fuel: true, duration: 2, depositId: 'copperPatch' },
    coalDrill: { label: 'Mining drill', kind: 'drill', output: 'coal', fuel: true, duration: 2, depositId: 'coalPatch' },
    siliconSmelter: { label: 'Silicon smelter', kind: 'smelter', inputs: ['siliconOre'], output: 'siliconBar', fuel: true, duration: 2 },
    circuitFabricator: { label: 'Circuit fabricator', kind: 'fabricator', inputs: ['siliconBar', 'copperWire'], output: 'greenCircuit', fuel: false, duration: 1.5 },
    siliconDrill: { label: 'Silicon drill', kind: 'drill', output: 'siliconOre', fuel: true, duration: 2, depositId: 'siliconPatch' },
    botFabricator: { label: 'Coal-bot fabricator', kind: 'botFab', inputs: [], output: null, fuel: false, duration: 0 }
}

export const MACHINE_PORT_LAYOUTS = {
    circuitFabricator: {
        inputs: {
            siliconBar: { x: -1.35, y: -0.48, z: 0.08 },
            copperWire: { x: -1.35, y: 0.48, z: 0.08 }
        }
    }
}

export const getMachinePortLayout = (_type) =>
{
    const definition = MACHINE_TYPES[_type]
    const override = MACHINE_PORT_LAYOUTS[_type] ?? {}
    const inputs = Object.fromEntries((definition.inputs ?? []).map((_resource, _index) => [
        _resource,
        override.inputs?.[_resource] ?? { x: -1.35, y: 0.15 - _index * 0.55, z: 0.08 }
    ]))
    return {
        inputs,
        fuel: definition.fuel ? override.fuel ?? { x: 1.35, y: 0.15, z: 0.08 } : null,
        output: definition.output ? override.output ?? { x: 0, y: -1.35, z: 0.08 } : null
    }
}

export const getMachinePort = (_machine, _port, _resource = null) =>
{
    const layout = getMachinePortLayout(_machine.type)
    const local = _port === 'input' ? layout.inputs[_resource] : layout[_port]
    return local ? { x: _machine.x + local.x, y: _machine.y + local.y, z: local.z } : null
}

export const BUILD_SITES = [
    { id: 'ironSmelter', machineType: 'ironSmelter', x: -3, y: 4, recipe: { stone: 8, timber: 4 } },
    { id: 'ironFabricator', machineType: 'ironFabricator', x: 2.1, y: 4, recipe: { stone: 6, ironIngot: 6 } },
    { id: 'copperSmelter', machineType: 'copperSmelter', x: -3, y: -4, revealAfterProduction: true, recipe: { stone: 10, timber: 4, ironCog: 2 } },
    { id: 'copperFabricator', machineType: 'copperFabricator', x: 2.1, y: -4, recipe: { stone: 6, copperIngot: 6, ironCog: 4 } },
    { id: 'ironDrill', machineType: 'ironDrill', x: -6.545, y: 5.627, machineX: -8.744, machineY: 9.021, revealAfterProduction: true, recipe: { ironIngot: 8, ironCog: 6, copperWire: 4 } },
    { id: 'copperDrill', machineType: 'copperDrill', x: -6.694, y: -3.721, machineX: -8.744, machineY: -5.221, recipe: { ironIngot: 8, ironCog: 6, copperWire: 6 } },
    { id: 'coalDrill', machineType: 'coalDrill', x: 5.3, y: -4.3, machineX: 7.8, machineY: -5.8, recipe: { ironIngot: 8, ironCog: 6, copperWire: 8 } },
    { id: 'ironOreBeltSite', label: 'Iron ore belt', kind: 'belt', beltIds: ['ironOreBelt'], x: -5.6, y: 6.2, recipe: { ironCog: 4, copperWire: 2 } },
    { id: 'ironSplitBeltSite', label: 'Iron split belt', kind: 'belt', beltIds: ['ironSplitBelt'], x: -1.5, y: 1.2, recipe: { ironCog: 4, copperWire: 4 } },
    { id: 'copperOreBeltSite', label: 'Copper ore belt', kind: 'belt', beltIds: ['copperOreBelt'], x: -5.6, y: -2.2, recipe: { ironCog: 6, copperWire: 4 } },
    { id: 'copperSplitBeltSite', label: 'Copper split belt', kind: 'belt', beltIds: ['copperSplitBelt'], x: -1.5, y: -6.8, revealsResource: 'siliconOre', recipe: { ironCog: 6, copperWire: 6 } },
    { id: 'siliconSmelter', machineType: 'siliconSmelter', x: -3, y: -12, recipe: { stone: 12, timber: 4, ironCog: 6, copperWire: 6 } },
    { id: 'circuitFabricator', machineType: 'circuitFabricator', x: 2.1, y: -12, recipe: { stone: 8, ironCog: 8, copperWire: 8, siliconBar: 4 } },
    { id: 'siliconDrill', machineType: 'siliconDrill', x: -6.694, y: -17.963, machineX: -8.744, machineY: -19.463, revealAfterProduction: true, recipe: { ironIngot: 8, ironCog: 6, copperWire: 8, greenCircuit: 2 } },
    { id: 'botFabricator', machineType: 'botFabricator', x: 6.1, y: -11, recipe: { ironIngot: 12, ironCog: 8, copperWire: 8, greenCircuit: 4 } },
    { id: 'siliconNetworkSite', label: 'Silicon network', kind: 'belt', beltIds: ['siliconOreNetworkBelt', 'siliconBarNetworkBelt', 'copperWireNetworkBelt'], x: -1.5, y: -15, recipe: { ironCog: 12, copperWire: 12, greenCircuit: 6 } }
]

export const BELT_DEFINITIONS = [
    {
        id: 'ironOreBelt', resource: 'ironOre', source: 'ironDrill', via: [{ x: -5.6, y: 7.671 }, { x: -5.6, y: 4.15 }],
        destinations: [{ machine: 'ironSmelter', input: 'ironOre' }]
    },
    {
        id: 'ironSplitBelt', resource: 'ironIngot', source: 'ironSmelter', via: [{ x: -3, y: 0 }, { x: -0.45, y: 0 }], split: true,
        destinations: [
            { machine: 'ironFabricator', input: 'ironIngot', via: [{ x: -0.45, y: 4.15 }] },
            { ground: 'ironGround', x: 1, y: 0 }
        ]
    },
    {
        id: 'copperOreBelt', resource: 'copperOre', source: 'copperDrill', via: [{ x: -5.6, y: -6.571 }, { x: -5.6, y: -3.85 }],
        destinations: [{ machine: 'copperSmelter', input: 'copperOre' }]
    },
    {
        id: 'copperSplitBelt', resource: 'copperIngot', source: 'copperSmelter', via: [{ x: -3, y: -8 }, { x: -0.45, y: -8 }], split: true,
        destinations: [
            { machine: 'copperFabricator', input: 'copperIngot', via: [{ x: -0.45, y: -3.85 }] },
            { ground: 'copperGround', x: 1, y: -8 }
        ]
    },
    {
        id: 'siliconOreNetworkBelt', resource: 'siliconOre', source: 'siliconDrill', via: [{ x: -5.6, y: -20.813 }, { x: -5.6, y: -11.85 }],
        destinations: [{ machine: 'siliconSmelter', input: 'siliconOre' }]
    },
    {
        id: 'siliconBarNetworkBelt', resource: 'siliconBar', source: 'siliconSmelter', via: [{ x: -3, y: -16 }, { x: -0.45, y: -16 }, { x: -0.45, y: -12.48 }],
        destinations: [{ machine: 'circuitFabricator', input: 'siliconBar' }]
    },
    {
        id: 'copperWireNetworkBelt', resource: 'copperWire', source: 'copperFabricator', via: [{ x: 2.1, y: -7.5 }, { x: 3.5, y: -7.5 }], split: true,
        destinations: [
            { machine: 'circuitFabricator', input: 'copperWire', via: [{ x: 3.5, y: -10.25 }, { x: 0.75, y: -10.25 }] },
            { ground: 'copperWireGround', x: 4.9, y: -7.5 }
        ]
    }
]

export const BOT_ORDER = {
    id: 'botOrder',
    label: 'Coal bot',
    x: 6.1,
    y: -13,
    baseRecipe: { ironIngot: 4, ironCog: 4, copperWire: 4, greenCircuit: 1 }
}

export const getBotOrderRecipe = (_botCount) => Object.fromEntries(
    Object.entries(BOT_ORDER.baseRecipe).map(([_resource, _amount]) => [_resource, Math.ceil(_amount * Math.pow(1.5, _botCount))])
)
